// extracted by mini-css-extract-plugin
export default {"icon":"Navigation-icon-104c5504c5382623253f98445f1f1c5e"};